import { downloadFile } from "@/services";
import { supplierRequestsAPI } from "@/views/SupplierRequests/services/api";

export const getSupplierRequests = async (params) => {
  try {
    const res = await supplierRequestsAPI.getList(params);
    return res;
  } catch (e) {
    console.error('Error fetching supplier requests:', e);
    return null;
  }
};

export const getSupplierRequestItems = async (providerRequestId) => {
  try {
    const res = await supplierRequestsAPI.getItems(providerRequestId);
    return res?.data || [];
  } catch (e) {
    console.error('Error fetching request items:', e);
    return [];
  }
};

export const exportSupplierRequestMaterials = async (params) => {
  try {
    await downloadFile(
      "/supplier/materials/export/",
      "Материалы_заявок_поставщику",
      params,
      "xlsx",
      "get",
      true
    );
    return true;
  } catch (e) {
    return null;
  }
};

export const getStatuses = async () => {
  try {
    const res = await supplierRequestsAPI.getStatuses();
    return res?.data || [];
  } catch (e) {
    console.error('Error fetching statuses:', e);
    return [];
  }
};

export const getPurchaseTypes = async () => {
  try {
    const res = await supplierRequestsAPI.getPurchaseTypes();
    return res?.data || [];
  } catch (e) {
    console.error('Error fetching purchase types:', e);
    return [];
  }
};

export const getInitiatorTypes = async () => {
  try {
    const res = await supplierRequestsAPI.getInitiatorTypes();
    return res?.data || [];
  } catch (e) {
    console.error('Error fetching initiator types:', e);
    return [];
  }
};

export const getMaterials = async (search = '', limit = 50) => {
  try {
    const res = await supplierRequestsAPI.getMaterials(search, limit);
    return res?.data || [];
  } catch (e) {
    console.error('Error fetching materials:', e);
    return [];
  }
};

export const getMaterialsPoddon = async () => {
  try {
    const res = await supplierRequestsAPI.getMaterialsPoddon();
    return res?.data || [];
  } catch (e) {
    console.error('Error fetching PODDON materials:', e);
    return [];
  }
};

export const addSupplierRequestItem = async (providerRequestId, payload) => {
  try {
    const res = await supplierRequestsAPI.addRequestItem(providerRequestId, payload);
    return res;
  } catch (e) {
    console.error('Error adding supplier request item:', e);
    throw e;
  }
};

export const deleteSupplierRequestItem = async (providerRequestItemId) => {
  try {
    const res = await supplierRequestsAPI.deleteProviderRequestItem(providerRequestItemId);
    return res;
  } catch (e) {
    console.error('Error deleting supplier request item:', e);
    throw e;
  }
};

// Накладные
export const getInvoices = async (providerRequestId) => {
  try {
    const res = await supplierRequestsAPI.getInvoices(providerRequestId);
    return res?.data || [];
  } catch (e) {
    console.error('Error fetching invoices:', e);
    return [];
  }
};

export const getInvoice = async (providerRequestInvoiceId) => {
  try {
    const res = await supplierRequestsAPI.getInvoice(providerRequestInvoiceId);
    return res?.data || null;
  } catch (e) {
    console.error('Error fetching invoice:', e);
    return null;
  }
};

export const getInvoiceItems = async (providerRequestInvoiceId) => {
  try {
    const res = await supplierRequestsAPI.getInvoiceItems(providerRequestInvoiceId);
    return res?.data || [];
  } catch (e) {
    console.error('Error fetching invoice items:', e);
    return [];
  }
};

export const downloadInvoice = async (providerRequestInvoiceId) => {
  const response = await supplierRequestsAPI.downloadInvoice(providerRequestInvoiceId);
  return response;
};

export const downloadInvoiceScan = async (providerRequestInvoiceId) => {
  const response = await supplierRequestsAPI.downloadInvoiceScan(providerRequestInvoiceId);
  return response;
};

export const getItemsForInvoice = async (providerRequestId) => {
  try {
    const res = await supplierRequestsAPI.getItemsForInvoice(providerRequestId);
    return res?.data || [];
  } catch (e) {
    console.error('Error fetching items for invoice:', e);
    return [];
  }
};

export const updateMaterialProvider = async (data) => {
  try {
    const res = await supplierRequestsAPI.updateMaterialProvider(data);
    return res;
  } catch (e) {
    console.error('Error updating material provider:', e);
    throw e;
  }
};

export const checkInvoiceNum = async (invoiceNum, providerId) => {
  try {
    const res = await supplierRequestsAPI.checkInvoiceNum(invoiceNum, providerId);
    return res;
  } catch (e) {
    return null;
  }
};

export const createInvoice = async (data) => {
  try {
    const res = await supplierRequestsAPI.createInvoice(data);
    return res;
  } catch (e) {
    console.error('Error creating invoice:', e);
    throw e;
  }
};

export const uploadSignedInvoice = async (data) => {
  try {
    const res = await supplierRequestsAPI.uploadSignedInvoice(data);
    return res;
  } catch (e) {}
};

export const changeItemStatus = async (providerRequestItemId, newStatusId) => {
  try {
    const res = await supplierRequestsAPI.changeItemStatus(providerRequestItemId, newStatusId);
    return res;
  } catch (e) {
    console.error('Error changing item status:', e);
    throw e;
  }
};

export const signInvoice = async (providerRequestInvoiceId) => {
  try {
    const res = await supplierRequestsAPI.signInvoice(providerRequestInvoiceId);
    return res;
  } catch (e) {
    console.error('Error signing invoice:', e);
    throw e;
  }
};

export const deleteInvoice = async (providerRequestInvoiceId) => {
  try {
    const res = await supplierRequestsAPI.deleteInvoice(providerRequestInvoiceId);
    return res;
  } catch (e) {
    console.error('Error deleting invoice:', e);
    throw e;
  }
};

export const updateInvoice = async (providerRequestInvoiceId, data) => {
  try {
    const res = await supplierRequestsAPI.updateInvoice(providerRequestInvoiceId, data);
    return res;
  } catch (e) {
    console.error('Error updating invoice:', e);
    throw e;
  }
};

export const deleteInvoiceItem = async (providerRequestInvoiceItemId) => {
  try {
    const res = await supplierRequestsAPI.deleteInvoiceItem(providerRequestInvoiceItemId);
    return res;
  } catch (e) {
    console.error('Error deleting invoice item:', e);
    throw e;
  }
};

export const updateInvoiceItemQty = async (providerRequestInvoiceItemId, materialCnt, materialPrice) => {
  try {
    const res = await supplierRequestsAPI.updateInvoiceItemQty(providerRequestInvoiceItemId, materialCnt, materialPrice);
    return res;
  } catch (e) {
    console.error('Error updating invoice item qty:', e);
    throw e;
  }
};

export const addInvoiceItem = async (providerRequestInvoiceId, providerRequestItemId, materialCnt, materialPrice) => {
  try {
    const res = await supplierRequestsAPI.addInvoiceItem(providerRequestInvoiceId, providerRequestItemId, materialCnt, materialPrice);
    return res;
  } catch (e) {
    console.error('Error adding invoice item:', e);
    throw e;
  }
};

export const getAvailableItemsForInvoice = async (providerRequestInvoiceId) => {
  try {
    const res = await supplierRequestsAPI.getAvailableItemsForInvoice(providerRequestInvoiceId);
    return res?.data || [];
  } catch (e) {
    console.error('Error fetching available items for invoice:', e);
    return [];
  }
};

// Реализации
export const getRealizes = async (providerRequestId) => {
  try {
    const res = await supplierRequestsAPI.getRealizes(providerRequestId);
    return res?.data || [];
  } catch (e) {
    console.error('Error fetching realizes:', e);
    return [];
  }
};

export const getRealize = async (realizeId) => {
  try {
    const res = await supplierRequestsAPI.getRealize(realizeId);
    return res?.data || null;
  } catch (e) {
    console.error('Error fetching realize:', e);
    return null;
  }
};

export const getRealizeItems = async (realizeId) => {
  try {
    const res = await supplierRequestsAPI.getRealizeItems(realizeId);
    return res?.data || [];
  } catch (e) {
    console.error('Error fetching realize items:', e);
    return [];
  }
};

export const downloadRealize = async (realizeId) => {
  const response = await supplierRequestsAPI.downloadRealize(realizeId);
  return response;
};

export const getSbsProjects = async (search = '', page = 1, limit = 50) => {
  try {
    const res = await supplierRequestsAPI.getSbsProjects(search, page, limit);
    return res?.data || [];
  } catch (e) {
    console.error('Error fetching SBS projects:', e);
    return [];
  }
};

export const getRequiredTypes = async () => {
  try {
    const res = await supplierRequestsAPI.getRequiredTypes();
    return res?.data || [];
  } catch (e) {
    console.error('Error fetching required types:', e);
    return [];
  }
};

export const requestsColumns = [
  {
    name: "provider_request_id",
    field: "provider_request_id",
    label: "ID / Иниц.",
    align: "center",
    style: "width: 80px",
  },
  {
    name: "date_send",
    field: "date_send",
    label: "Создано",
    align: "center",
    style: "width: 96px",
  },
  {
    name: "project_name",
    field: "project_name",
    label: "ЖК",
    align: "left",
  },
  {
    name: "provider_info",
    field: "provider_name",
    label: "Поставщик / Тип",
    align: "left",
  },
  {
    name: "provider_request_status_name",
    field: "provider_request_status_name",
    label: "Статус",
    align: "center",
  },
  {
    name: "items_count",
    field: "items_count",
    label: "Поз.",
    align: "center",
    style: "width: 50px",
  },
  {
    name: "items_total",
    field: "items_total",
    label: "Сумма",
    align: "right",
  },
  {
    name: "invoice_info",
    field: "invoice_info",
    label: "Накладные",
    align: "center",
  },
  {
    name: "realizes_info",
    field: "realizes_info",
    label: "Реализации",
    align: "center",
  },
  {
    name: "expand",
    field: "expand",
    label: "Детали",
    align: "center",
    style: "width: 64px",
  },
];

export const itemsColumns = [
  {
    name: "provider_request_item_id",
    field: "provider_request_item_id",
    label: "ID",
    align: "center",
    style: "width: 60px",
  },
  {
    name: "material_name",
    field: "material_name",
    label: "Материал",
    align: "left",
    style: "max-width: 280px",
  },
  {
    name: "date_shipping",
    field: "date_shipping",
    label: "Отгрузка",
    align: "center",
    style: "width: 100px",
  },
  {
    name: "material_cnt",
    field: "material_cnt",
    label: "Кол-во",
    align: "center",
    style: "width: 100px",
  },
  {
    name: "price",
    field: "price",
    label: "Цена",
    align: "right",
    style: "width: 100px",
  },
  {
    name: "item_sum",
    field: "item_sum",
    label: "Сумма",
    align: "right",
    style: "width: 120px",
  },
  {
    name: "provider_request_status_name",
    field: "provider_request_status_name",
    label: "Статус",
    align: "center",
    style: "width: 150px",
  },
  {
    name: "certificate_urls",
    field: "certificate_urls",
    label: "Сертификаты",
    align: "center",
    style: "width: 120px",
  },
  {
    name: "invoices_info",
    field: "invoices_info",
    label: "Накладная",
    align: "left",
  },
  {
    name: "actions",
    field: "actions",
    label: "",
    align: "center",
    style: "width: 60px",
  },
];

